import { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { AppContext } from '@/common/hooks/useAppContext';
import ModalError from '@/components/ModalError';
import { Footer } from '@/entities/Footer';
import { Header } from '@/entities/Header';
import { useScrollToTop } from '@/entities/Layout/useScrollToTop';

export const Layout = () => {
  useScrollToTop();
  const { errorMessage, setErrorMessage } = useContext(AppContext);
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      {!!errorMessage && (
        <ModalError
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
        />
      )}
    </>
  );
};
